import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AccordionStateType = {
  cropTrendsListPage: {
    [key: string]: boolean; // middleCategoryCode를 키로 사용
  };
  savedAccordionStates: {
    [key: string]: boolean; // middleCategoryCode를 키로 사용하여 이전 상태 저장
  };
};

const initialState: AccordionStateType = {
  cropTrendsListPage: {},
  savedAccordionStates: {},
};

export const accordionSlice = createSlice({
  name: 'accordion',
  initialState,
  reducers: {
    toggleCropTrendsAccordion: (state, action: PayloadAction<{ middleCategoryCode: string; isOpen: boolean }>) => {
      const { middleCategoryCode, isOpen } = action.payload;
      state.cropTrendsListPage[middleCategoryCode] = isOpen;
    },
    resetCropTrendsAccordions: (state) => {
      state.cropTrendsListPage = {};
    },
    saveAccordionStates: (state) => {
      state.savedAccordionStates = { ...state.cropTrendsListPage };
    },
    restoreAccordionStates: (state) => {
      state.cropTrendsListPage = { ...state.savedAccordionStates };
    },
  },
});

export const { toggleCropTrendsAccordion, resetCropTrendsAccordions, saveAccordionStates, restoreAccordionStates } =
  accordionSlice.actions;
